import React, { useState, useEffect, useContext } from "react";
import "./Report.css";
import { AuthContext } from "./../../ContextApi/ContextApi";
import { useNavigate } from "react-router-dom";
import { SAVED_URL } from "../../api/apiurls";
import Navbar from "../../shared/Navbar";
import Swal from "sweetalert2";

const Report = () => {
  const { firstName, userName: username, licenseEndDate } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const savedUrl = `${SAVED_URL}${username}`;

  // 🔥 CHECK LICENSE EXPIRY — SHOW POPUP IF <= 15 DAYS
  useEffect(() => {
    if (!licenseEndDate) return;

    const today = new Date();
    const expiryDate = new Date(licenseEndDate);

    const diffTime = expiryDate - today;
    const daysLeft = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    if (daysLeft <= 15) {
      Swal.fire({
        icon: "warning",
        title: "Subscription Expiry Alert",
        text: `Your subscription will expire in ${daysLeft} days.`,
        confirmButtonText: "OK"
      });
    }
  }, [licenseEndDate]);

  // 🔽 FETCH DATA
  useEffect(() => {
    const getAccountDetails = async () => {
      try {
        const response = await fetch(savedUrl);
        const readSave = await response.json();
        setData(readSave);
      } finally {
        setLoading(false);
      }
    };
    getAccountDetails();
  }, [username]);

  const handlePrint = () => {
    navigate("/report-bluetooth", { state: { data } });
  };

  const goReadSheet = (item) => {
    navigate("/ReadReport", {
      state: {
        RecieptNo: item.id,
        firstName: firstName,
        agentUserName: item.AgentName,
        Phone: item.Phone,
        PresentBalance: item.PresentBalance,
        AccountType: item.AccountType,
        Name: item.Name,
        AccountNo: item.AccountNo,
        Recieved: item.Recieved,
      },
    });
  };

  const totalReceived = data.reduce((sum, item) => sum + Number(item.Recieved), 0);

  return (
    <div>
      <Navbar />

      <div className="ReportContainer">
        <div className="ReportTopBar">
          <button className="ReportPrintBtn" onClick={handlePrint}>
            Print
          </button>
        </div>

        <div className="ReportHeaderRow">
          <div className="ReportHeaderCell">AccountNo</div>
          <div className="ReportHeaderCell">Recieved</div>
        </div>

        {loading ? (
          <p className="ReportLoading">Loading...</p>
        ) : (
          <>
            {data.map((item) => (
              <div key={item.id} className="ReportDataRow">
                <div className="ReportCell" onClick={() => goReadSheet(item)}>
                  {item.AccountNo}
                </div>
                <div className="ReportCell" onClick={() => goReadSheet(item)}>
                  {item.Recieved}
                </div>
              </div>
            ))}

            <div className="ReportDataRow mt-5">
              <div className="ReportCell"><h1>Total</h1></div>
              <div className="ReportCell"><h1>{totalReceived}</h1></div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default Report;
